import type { Engine, ISourceOptions } from '@tsparticles/engine';
import TSParticles, { ParticlesProvider } from '@tsparticles/react';
import React from 'react';
import { loadFull } from 'tsparticles';

import colors from '../assets/scss/_colors.scss';

// Both must keep a stable identity: the provider throws if `init` changes,
// and the particles reload whenever `options` changes.
const init = async (engine: Engine) => {
    await loadFull(engine);
};

const options: ISourceOptions = {
    background: {
        color: {
            value: 'transparent',
        },
    },
    fpsLimit: 60,
    resize: {
        enable: true,
    },
    interactivity: {
        events: {
            onClick: {
                enable: true,
                mode: 'push',
            },
            onHover: {
                enable: false,
                mode: 'repulse',
            },
        },
        modes: {
            push: {
                quantity: 2,
            },
            repulse: {
                distance: 180,
                duration: 2000,
            },
        },
    },
    particles: {
        paint: {
            color: {
                value: [colors['primary-500'], colors['surface-100']],
            },
        },
        links: {
            color: colors['surface-100'],
            distance: 300,
            enable: true,
            opacity: 1,
            width: 1,
        },
        collisions: {
            enable: false,
        },
        move: {
            direction: 'none',
            enable: true,
            outModes: {
                default: 'split',
            },
            random: false,
            speed: 0.15,
            straight: false,
        },
        number: {
            density: {
                enable: true,
                width: 1000,
            },
            value: 30,
        },
        opacity: {
            value: 1,
        },
        shape: {
            type: 'square',
        },
        size: {
            value: { min: 1, max: 3 },
        },
    },
    detectRetina: true,
};

const Particles = () => {
    return (
        <ParticlesProvider init={init}>
            <TSParticles
                className="particles"
                id="particles"
                options={options}
            />
        </ParticlesProvider>
    );
};

export default Particles;
